import { createComponentClickedEvent, track } from "@/analytics/events/base"

export const marketTrendsButtonClicked = () => {
  track(
    createComponentClickedEvent({
      current_screen: "Analyze",
      component_type: "button",
      component_function: "user clicks on market data component",
      component_text: "market trends for",
    })
  )
}
